export function populateAddressOptions(col = {}, item = {}) {
  if (!col?.ref?.map || !col.ref.colAddressType) return [];

  const ref = col.ref;
  // const mapEntries = Object.entries(ref.map); // [key, value] pairs
  let options = [];

  options = Array.from(ref.map.values())
    .filter(val => {
      if (col.ref.colAddressType === 'city') {
        return val.province === item[col.ref.referencedCol];
      } else if (col.ref.colAddressType === 'barangay') {
        return (
          val.province === item[col.ref.referencedCol] &&
          val.city === item[col.ref.referencedCol2]
        );
      }
      return true;
    })
    .map(val => ({
      label: val.name,
      value: val.name
    }));

  return options;
}
